export var AssessmentActivityStatus;
(function (AssessmentActivityStatus) {
    AssessmentActivityStatus["Complete"] = "complete";
    AssessmentActivityStatus["InProgress"] = "inprogress";
    AssessmentActivityStatus["NotStarted"] = "notstarted";
})(AssessmentActivityStatus || (AssessmentActivityStatus = {}));
//# sourceMappingURL=assessment-activity-status.js.map